import {
  RouterProvider, createBrowserRouter, RouteObject, Navigate
} from "react-router-dom";
import { Spin } from "antd";

import Home from "../../pages/Home";
import Login from "../../pages/Login";
import Survey from "../../pages/Survey";
import ResetPassword from "../../pages/ResetPassword";
import MatchingProcess from "../../pages/MatchingProcess";
import Registration from "../../pages/Registration";
import AuthLayout from "../AuthLayout";
import Book from "../../landing/pages/Book";

import ProtectedRoute from "./protectedRoute";
import AuthRoute from "./authRoute";

import {
  LOGIN_PATH,
  MATCHING_PROCESS_PATH,
  RESET_PASSWORD_PATH,
  APP_PATH,
  SIGNUP_PATH,
  SURVEY_PATH,
  CANCEL_PATH,
  SUCCESS_PATH,
  VIDEO_PATH,
  BOOKING_PATH,
  APPOINTMENT_EDIT_PATH,
  FEEDBACK_PATH,
  APPOINTMENTS_PATH,
  MESSAGES_PATH,
  AVAILABILITY_PATH,
  SETTINGS_PATH,
  LANDING_PATH_SEARCH_DOCTOR,
} from "../../constants/routes";
import AppointmentEdit from "../../pages/AppointmentEdit";
import Messages from "../../pages/Messages";
import Availability from "../../pages/Availability";
import Video from "../../video";
import MainRoute from "./mainRoute";
import DashboardLayout from "../DashboardLayout";
import Appointments from "../../pages/Appointments";
import AppointmentBook from "../../pages/AppointmentBook";
import Settings from "../../pages/Settings";
import Result from "../../pages/Result";
import Feedback from "../../pages/Feedback";
import Index from "../../landing";
import NotFound from "../../landing/pages/NotFound";
import AboutUs from "../../landing/pages/AboutUs";
import Landing from "../../landing/pages/Landing";
import Contacts from "../../landing/pages/Contacts";
import Experts from "../../landing/pages/Experts";
import ExpertDetails from "../../landing/pages/ExpertDetails";
import SearchDoctor from "../../landing/pages/SearchDoctor";
import Faq from "../../landing/pages/Faq";
import PsychoOncology from "../../landing/pages/PsychoOncology";
import HowItWorksPage from "../../landing/pages/HowItWorksPage";
import TermsAndConditions from "../../landing/pages/TermsAndConditions";
import PrivacyPolicy from "../../landing/pages/PrivacyPolicy";

export const routesConfig: RouteObject[] = [
  {
    path: "/",
    element: <Index />,
    errorElement: <NotFound />,
    children: [
      {
        element: <Landing/>,
        index: true,
      },
      {
        path: "chi-siamo",
        element: <AboutUs/>
      },
      {
        path: "contatti",
        element: <Contacts/>
      },
      {
        path: "psiconcologi",
        element: <Experts/>
      },
      {
        path: "book",
        element: <Book/>
      },
      {
        path: LANDING_PATH_SEARCH_DOCTOR,
        element: <SearchDoctor/>
      },
      {
        path: "psiconcologi/:entity",
        element: <ExpertDetails/>
      },
      {
        path: "faq",
        element: <Faq/>
      },
      {
        path: "psiconcologia",
        element: <PsychoOncology/>
      },
      {
        path: "come-funziona",
        element: <HowItWorksPage/>
      },
      {
        path: "termini-e-condizioni",
        element: <TermsAndConditions/>
      },
      {
        path: "informativa-privacy",
        element: <PrivacyPolicy/>
      },
      {
        path: "success",
        element: <Result />,
      },
    ]
  },
  {
    path: APP_PATH,
    errorElement: <Navigate to={APP_PATH} />,
    children: [
      {
        element: <ProtectedRoute/>,
        children: [
          {
            element: <MainRoute/>,
            children: [
              {
                element: <DashboardLayout/>,
                children: [
                  {
                    index: true,
                    element: <Home /> // Dashboard
                  },
                  {
                    path: APPOINTMENTS_PATH,
                    element: <Appointments/>
                  },
                  {
                    path: APPOINTMENT_EDIT_PATH,
                    element: <AppointmentEdit/>
                  },
                  {
                    path: BOOKING_PATH,
                    element: <AppointmentBook/>
                  },
                  {
                    path: MESSAGES_PATH,
                    element: <Messages/>
                  },
                  {
                    path: AVAILABILITY_PATH,
                    element: <Availability/>
                  },
                  {
                    path: SETTINGS_PATH,
                    element: <Settings />
                  },
                ]
              },
              {
                path: SUCCESS_PATH,
                element: <Result />,
              },
              {
                path: CANCEL_PATH,
                element: <Result />,
              },
              {
                path: VIDEO_PATH,
                element: <Video/>
              },
              {
                path: FEEDBACK_PATH,
                element: <Feedback/>
              },
            ]
          }
        ]
      },
      {
        element: <AuthRoute/>,
        children: [
          {
            path: LOGIN_PATH,
            element: <AuthLayout />,
            children: [
              {
                index: true,
                element: <Login />,
              },
              {
                path: RESET_PASSWORD_PATH,
                element: <ResetPassword />
              },
            ]
          },
          {
            path: SIGNUP_PATH,
            children: [
              {
                element: <AuthLayout />,
                children: [
                  {
                    index: true,
                    element: <Registration />
                  },
                ]
              },
              {
                children: [
                  {
                    path: SURVEY_PATH,
                    element: <Survey />
                  },
                  {
                    path: MATCHING_PROCESS_PATH,
                    element: <MatchingProcess />
                  }
                ]
              }
            ]
          },
        ]
      },
    ],
  }
];

const router = createBrowserRouter(routesConfig);

const Routes = () => {
  return <RouterProvider router={router} fallbackElement={<Spin size="large" fullscreen />}/>;
};

export default Routes;
